import React from 'react';

import { SigningOrderEditor, SigningOrderEditorParty } from '../../components/SigningOrderEditor';
import { AGREEMENT_SIGNER_ROLE, SigningMode } from '../../components/signing-order.types';
import { normalizeSigningParties } from '../../components/signing-order.utils';

interface Step2SignersProps {
    documentRecipients: any[];
    roleOptions: any[];
    isViewMode?: boolean;
    getCustomerSuggestionsForRow: (idx: number) => any[];
    searchCustomers: (e: any) => void;
    createCustomer: (idx: number) => void;
    handleRecipientChange: (idx: number, field: string, value: any) => void;
    setDocumentRecipients?: (recipients: any[]) => void;
    addRecipient: () => void;
    removeRecipient: (idx: number) => void;
    getRoleOptionsForRow: (idx: number) => any[];
    isTemplateMode?: boolean;
    isSequential?: boolean;
    signingMode?: SigningMode;
    onSigningModeChange?: (mode: SigningMode) => void;
}

export const Step2Signers: React.FC<Step2SignersProps> = ({
    documentRecipients,
    isViewMode = false,
    getCustomerSuggestionsForRow,
    searchCustomers,
    createCustomer,
    handleRecipientChange,
    setDocumentRecipients,
    signingMode = 'AgtSignSequential',
    onSigningModeChange = () => {}
}) => {
    const parties: SigningOrderEditorParty[] = documentRecipients.map((recipient, index) => ({
        ...recipient,
        _internalId: recipient._internalId || crypto.randomUUID(),
        partyId: recipient.partyId || recipient.party?.partyId || recipient.party?.value || '',
        roleTypeId: AGREEMENT_SIGNER_ROLE,
        emailAddress: recipient.emailAddress || '',
        sequenceNum: Number(recipient.sequenceNum ?? recipient.signingOrder) || index + 1
    }));

    const handleEditorChange = (nextParties: SigningOrderEditorParty[]) => {
        const normalized = normalizeSigningParties(nextParties).map((party, index) => ({
            ...party,
            _internalId: (party as any)._internalId || crypto.randomUUID(),
            party: (party as any).party || null,
            taxCode: (party as any).taxCode || '',
            partyName: party.partyName || (party as any).party?.partyName || '',
            emailAddress: party.emailAddress || '',
            contactNumber: (party as any).contactNumber || '',
            representativeName: (party as any).representativeName || '',
            identityCard: (party as any).identityCard || '',
            partyTypeEnumId: (party as any).partyTypeEnumId,
            roleTypeId: AGREEMENT_SIGNER_ROLE,
            signingOrder: party.sequenceNum || index + 1
        }));

        if (setDocumentRecipients) {
            setDocumentRecipients(normalized);
            return;
        }

        normalized.forEach((party, index) => {
            handleRecipientChange(index, 'sequenceNum', party.sequenceNum);
            handleRecipientChange(index, 'roleTypeId', AGREEMENT_SIGNER_ROLE);
            handleRecipientChange(index, 'emailAddress', party.emailAddress || '');
        });
    };

    return (
        <div className="grid">
            <div className="col-12 mb-3">
                <span className="text-xl font-bold">Danh sách người nhận</span>
            </div>
            <div className="col-12">
                <SigningOrderEditor
                    parties={parties}
                    onChange={handleEditorChange}
                    signingMode={signingMode}
                    onSigningModeChange={onSigningModeChange}
                    getPartySuggestions={getCustomerSuggestionsForRow}
                    searchParties={searchCustomers}
                    onPartyChange={(rowIndex, party) => handleRecipientChange(rowIndex, 'party', party)}
                    onCreateParty={createCustomer}
                    disabled={isViewMode}
                />
            </div>
        </div>
    );
};
